import axios from 'axios';
import SettingMer from '@/utils/settingMer';
axios.defaults.baseURL = SettingMer.httpUrl;
var service = axios.create({
  timeout: 40000,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'Content-Type': 'application/json; charset=UTF-8'
  }
});
service.interceptors.request.use(function (config) {
  return config;
}, function (error) {
  Promise.reject(error);
});

// response interceptor
service.interceptors.response.use(function (response) {
  var res = response.data;
  return res;
}, function (error) {});
export default service;